<section fxLayout="row" class="h-100">
    <section [formGroup]="form" fxLayoutAlign="center center" fxFlex="1 1 auto"
        class="sen-info-color-bg sen-body-max-width">
        <div formArrayName="roofDimension" class="sen-roof-shape-container"
            [ngClass]="'sen-roof-' + defaultSelectedRoofShape.value"
            [ngStyle]="{'background-image': 'url(' + defaultSelectedRoofShape.image + ')'}">
            <div class="sen-roof-unit text-white d-inline-block" color="invalid">{{translate.getLng('ROOF_MEASURE_CM')}}
            </div>
            <div class="sen-form-field-wrapper sen-roof-shape-input">
                <ng-container *ngFor="let m of roofDimension.controls; let i = index;">
                    <div *ngIf="i < defaultSelectedRoofShape.measurement.length" class="position-absolute">
                        <span
                            class="sen-roof-shape-badge badge border border-white sen-fs12 badge-pill badge-warning font-weight-bold py-2">{{allLabels[i].label}}</span>
                        <div class="d-inline-block badge-warning p-1">
                            <input class="bg-white d-inline border-0 pl-2" [formControlName]="i" matInput
                                autocomplete="off" mask="000000" type="text">
                        </div>
                    </div>
                </ng-container>
                <div fxLayout="column" fxLayoutAlign="center center" class="position-absolute sen-height-unit">
                    <div class="mb-4 sen-total-height sen-fs10 text-center border border-white badge-warning">
                        {{translate.getLng('BUILDING_HEIGHT')}}
                    </div>
                    <div class="d-inline-block badge-warning p-1">
                        <mat-select [formControl]="roofHeight" class="d-inline-block bg-white d-inline pl-2">
                            <mat-option *ngFor="let h of aBuildingHeight" [value]="h">
                                {{translate.getLng('up_to')}} {{h}} m
                            </mat-option>
                        </mat-select>
                    </div>
                </div>

                <div class="position-absolute sen-roof-type sen-fs10 text-center font-weight-bold badge-warning">
                    {{defaultSelectedRoofShape.measurement.length ? this.translate.getLng('ROOFTYPE') + ' : ' +
                defaultSelectedRoofShape.type : defaultSelectedRoofShape.info}}
                </div>
            </div>
        </div>
    </section>
    <section fxLayout="column" class="px-2 sen-tool-bar sen-light-blue-bg">
        <div fxFlex="1 1 auto">
            <h2 class="pt-2">{{translate.getLng('ROOFSHAPE')}}</h2>
            <div class="mx-4" class="sen-roof-icon">
                <mat-card class="d-inline-block sen-cursor-pointer p-1 my-2 text-center" fxFlex="1 1 26%"
                    *ngFor="let i of roofShapeArray" matBadge="&#x2713;" matBadgePosition="before"
                    matBadgeColor="primary" [matBadgeHidden]="defaultSelectedRoofShape.value != i.value"
                    (click)="setRoofShape(i)">
                    <img src="{{i.icon}}" title="{{i.type}}" width="50">
                </mat-card>
            </div>
            <hr class="border-white my-2">
            <div fxLayout="row" fxLayoutAlign="space-between center" class="sen-roof-pitch">
                <mat-form-field fxFlex="1 1 30%" class="ml-3">
                    <mat-label>{{translate.getLng('ROOFANGLE')}}</mat-label>
                    <mat-select [(ngModel)]="defaultPitch">
                        <mat-option *ngFor="let p of roofPitchArray" [value]="p">
                            {{p}}
                        </mat-option>
                    </mat-select>
                </mat-form-field>
                <div class="text-center" fxFlex="1 1 30%">
                    <img src="{{imagePath.assetsPath + imagePath.iconPath + 'Haus_' + defaultPitch + '.png'}}">
                </div>
            </div>
            <ng-container *ngIf="adhesiveTabVisible">
                <hr class="border-white my-2">
                <div fxLayout="row" fxLayoutAlign="space-between center" class="mx-3">
                    <label>{{translate.getLng('IDANSKLEBANCOL')}}</label>
                    <mat-select class="border-bottom border-dark ml-2" fxFlex="1 1 30%"
                        [(ngModel)]="defaultAdhesiveTap">
                        <mat-option *ngFor="let a of adhesiveTap" [value]="a">
                            {{a}}
                        </mat-option>
                    </mat-select>
                </div>
            </ng-container>
            <hr class="border-white my-2">
            <div *ngIf="defaultOrientation" class="sen-roof-orientation position-relative mx-auto mt-2 mb-3"
                fxLayout="row" fxLayoutAlign="center center">
                <span class="position-absolute badge badge-pill border sen-cursor-pointer border border-white"
                    [ngClass]="(defaultOrientation.direction == o.direction) ? 'badge-warning': 'bg-white'"
                    *ngFor="let o of orientationDataArray" (click)="changeOrientation(o)">{{o.direction}}</span>
                <img width="70" #orientationRoof src="{{imagePath.ORIENTATION_ROOF}}">
            </div>
            <mat-error *ngIf="roofDimension.hasError('wrongDimension')">b {{translate.getLng('MUST_BE_BIGGER')}} c
            </mat-error>
        </div>
        <div class="my-2" fxLayout="row" fxLayoutAlign="space-evenly center">
            <button class="px-5 py-2" mat-raised-button color="primary"
                (click)="navPrev()">{{translate.getLng('PREV')}}</button>
            <button class="px-5 py-2" mat-raised-button color="primary"
                (click)="navNext()">{{translate.getLng('NEXT')}}</button>
        </div>
    </section>
</section>